module.exports = __webpack_public_path__ + "media/images/city_img/b_3-30de37502e283417ac5e23366582b471.jpg";